export const MINIMUM_MENTOR_COUNT = 1;
export const MAXIMUM_MENTOR_COUNT = 50;
export const MAXIMUM_SUGGESTED_MENTOR_COUNT = 15;